/* eslint-disable no-use-before-define */
import React from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'

import LibertyLake from './views/LibertyLake/LibertyLake'
import IvyLeague from './views/IvyLeague/IvyLeague'
import { GotGameTemplate } from './views/GotGameTemplate'
import { LibertyLakeV2 } from './views/LibertyLake/LibertyLakeV2'

const App = () => {
  return (
    <Switch>
      <Route path='/liberty-lake' component={LibertyLake} />
      <Route path='/liberty-lake-v2' component={LibertyLakeV2} />
      <Route path='/ivy-league' component={IvyLeague} />
      <Route path='/' component={GotGameTemplate} />
      <Redirect to='/' />
    </Switch>
  )
}

export default App
